// Dynamic algorithm detail. Route: /algorithm/:specialty/:algoId

import React from "react";
import { useParams, Navigate } from "react-router-dom";
import AlgorithmDocument from "@/components/AlgorithmDocument";
import { SPECIALTIES, getAlgorithm } from "@/lib/algorithms";

export default function AlgorithmDetail() {
  const { specialty: specKey, algoId } = useParams();
  const specialty = SPECIALTIES[specKey];
  const algorithm = getAlgorithm(specKey, algoId);

  if (!specialty || !algorithm || !algorithm.available) {
    return <Navigate to={`/algorithm/${specKey || ""}`} replace />;
  }

  return (
    <AlgorithmDocument
      algorithm={algorithm}
      specialty={specialty}
      backTo={`/algorithm/${specKey}`}
    />
  );
}
